"use strict";

import angular from "angular";
import routes from "./direct-dr-member-authors.routes";
import DirectDrMemberAuthorsController from "./direct-dr-member-authors.controller";

export default angular
  .module("dalApp.directDrMemberAuthors", ["dalApp.auth", "ui.router"])
  .config(routes)
  .controller(
    "DirectDrMemberAuthorsController",
    DirectDrMemberAuthorsController
  ).name;



// WEBPACK FOOTER //
// ./client/app/direct-dr-member-authors/index.js